/*
 * Get Material Variant GraphQL specification
 * @module src/graphql/getMaterialVariant
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_MATERIAL_VARIANT = gql`
  query getMaterialVariant($productId: String) {
    getMaterialVariant(productId: $productId) {
      code
      variantOptionType
      description
      __typename
    }
  }
`;
